export default initData => {
    const { profileFeedbackMemberId } = initData.pageSpecificData;

    return {
        loadingModel: false,
        model: null,
        profileFeedbackMemberId,
        showTranslatedReviews: false,
        translatedReviews: [],
        translatedReviewsLoading: false,
        translatedReviewsLoadingError: false
    };
};
